import { UpgradeConfigProduct } from '../../../__generated__/chirp/com/hubspot/upgrade/management/rpc/UpgradeConfigInAppRpc';

export const UPGRADE_CONFIG_CACHE_KEY = 'HS_UPGRADE_CONFIG_CACHE';

export const writeUpgradeConfigToLocalStorage = (
  config: UpgradeConfigProduct
) => {
  try {
    localStorage.setItem(
      UPGRADE_CONFIG_CACHE_KEY,
      JSON.stringify({
        timestamp: Date.now(),
        upgradeConfig: config,
      })
    );
  } catch {
    // localStorage may be full or unavailable; silently fall back
  }
};
